import React from "react";
import { Link as MuiLink, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import Zoom from "@mui/material/Zoom";
import { tooltipStyles } from "./constants";
import menuItems from "pages/MainPage/constants";
import styles from "./ShortcutBar.styled";

const ShortcutBar = () => {
  return (
    <>
      {menuItems.map((item) => (
        <Tooltip
          key={item.title}
          title={item.title}
          placement="bottom"
          enterTouchDelay={0}
          arrow
          slotProps={tooltipStyles}
          slots={{
            transition: Zoom,
          }}
        >
          <MuiLink to={item.path} component={Link} sx={styles.iconWrap}>
            <item.icon />
          </MuiLink>
        </Tooltip>
      ))}
    </>
  );
};

export default ShortcutBar;
